import { render, staticRenderFns } from "./iconTrabajo.vue?vue&type=template&id=596b993f&scoped=true&"
import script from "./iconTrabajo.vue?vue&type=script&lang=js&"
export * from "./iconTrabajo.vue?vue&type=script&lang=js&"
import style0 from "./iconTrabajo.vue?vue&type=style&index=0&id=596b993f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596b993f",
  null
  
)

export default component.exports